var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningV3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81171 10.7615C8.73007 5.58716 10.1893 3 12.5 3C14.8107 3 16.2699 5.58716 19.1883 10.7615L19.5519 11.4063C21.9771 15.7061 23.1897 17.856 22.0937 19.428C20.9978 21 18.2864 21 12.8637 21H12.1363C6.71356 21 4.00217 21 2.90626 19.428C1.81034 17.856 3.02291 15.7061 5.44805 11.4063L5.81171 10.7615ZM12.5 7.25C12.9142 7.25 13.25 7.58579 13.25 8V13C13.25 13.4142 12.9142 13.75 12.5 13.75C12.0858 13.75 11.75 13.4142 11.75 13V8C11.75 7.58579 12.0858 7.25 12.5 7.25ZM12.5 17C13.0523 17 13.5 16.5523 13.5 16C13.5 15.4477 13.0523 15 12.5 15C11.9477 15 11.5 15.4477 11.5 16C11.5 16.5523 11.9477 17 12.5 17Z",
    fill: "#FF3B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81171 10.7615C8.73007 5.58716 10.1893 3 12.5 3C14.8107 3 16.2699 5.58716 19.1883 10.7615L19.5519 11.4063C21.9771 15.7061 23.1897 17.856 22.0937 19.428C20.9978 21 18.2864 21 12.8637 21H12.1363C6.71356 21 4.00217 21 2.90626 19.428C1.81034 17.856 3.02291 15.7061 5.44805 11.4063L5.81171 10.7615ZM12.5 7.25C12.9142 7.25 13.25 7.58579 13.25 8V13C13.25 13.4142 12.9142 13.75 12.5 13.75C12.0858 13.75 11.75 13.4142 11.75 13V8C11.75 7.58579 12.0858 7.25 12.5 7.25ZM12.5 17C13.0523 17 13.5 16.5523 13.5 16C13.5 15.4477 13.0523 15 12.5 15C11.9477 15 11.5 15.4477 11.5 16C11.5 16.5523 11.9477 17 12.5 17Z",
    fill: "url(#paint0_linear_6289_88299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6289_88299",
    x1: 13.7971,
    y1: 3,
    x2: 13.7971,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningV3);
export default __webpack_public_path__ + "static/media/warning-v3.bb26d8a8f30c20c7c3e9b7c834eafca4.svg";
export { ForwardRef as ReactComponent };